import React, { useState, useContext } from 'react'
import { SkyInformationPopover } from '../../Core/Popover/SkyPopover'
import FlexView from 'react-flexview/lib'

export const TooltipInformationSection = ({ title, limitationInfo }) => {
  return (
    <FlexView vAlignContent={'center'} className="margin-top-basic">
      <div className="text-body gray margin-right-6">{title}</div>
      <SkyInformationPopover style={{ fontSize: '0.9rem' }}>
        <div className="text-small">{limitationInfo}</div>
      </SkyInformationPopover>
    </FlexView>
  )
}
